import styled from "styled-components/macro";
import { Link } from "react-router-dom";
import { WebIcons } from "../../components/WebIcons/WebIcons";
import { VStack, HStack } from "@chakra-ui/react";
import { ViewHeader } from "../../components/ViewStyle/ViewStyle";
interface FeatureProps {
  title: string;
  feature: string;
  icon: string;
}

interface SectionProps {
  bgColor: string;
}

export const Section = styled.section<SectionProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: ${({ bgColor }) =>
    `linear-gradient(${bgColor} 100%, ${bgColor} 100%)`};
  padding: 1.25rem 0;
`;

export const FeatureDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  padding: 15px 10px;
  justify-content: center;
`;

export const Feature = styled(Link)<{ tilecolor: any }>`
  text-transform: uppercase;
  font-family: Fjalla One, sans-serif;
  text-decoration: none;
  height: 160px;
  width: 160px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: 10px;
  color: white;
  margin-left: 25px;
  margin-right: 25px;
  @media (max-width: 768px) {
    height: 100px;
    width: 100px;
    margin-left: 5px;
    margin-right: 5px;
  }
  @media (max-width: 480px) {
    height: 70px;
    width: 70px;
    margin-left: 5px;
    margin-right: 5px;
  }
  background-color: ${({ tilecolor }) => tilecolor};

  &:hover {
    background-color: #c6c6c6;
  }
`;

export const ExternalFeature = styled.a<{ tilecolor: any }>`
  text-transform: uppercase;
  font-family: Fjalla One, sans-serif;
  text-decoration: none;
  height: 160px;
  width: 160px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: 10px;
  margin-left: 25px;
  margin-right: 25px;
  color: white;
  @media (max-width: 768px) {
    height: 100px;
    width: 100px;
    margin-left: 5px;
    margin-right: 5px;
  }
  @media (max-width: 480px) {
    height: 70px;
    width: 70px;
    margin-left: 5px;
    margin-right: 5px;
  }
  background-color: ${({ tilecolor }) => tilecolor};

  &:hover {
    background-color: #c6c6c6;
  }
`;
export const FeatureTitle = styled.p`
  width: 160px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  font-size: 1.25rem;
  font-family: Fjalla One;
  color: white;
  padding-bottom: 30px;
  text-align: center;
  -webkit-hyphens: auto;
  -moz-hyphens: auto;
  hyphens: auto;
  line-height: tight;
  @media (max-width: 768px) {
    font-size: 1rem;
    width: 100px;
  }
  @media (max-width: 480px) {
    font-size: 0.8rem;
    width: 90px;
  }
`;

export const VerticalLine = styled.div<{ verticalcolor: any }>`
  border-left: 4px solid;
  border-color: ${({ verticalcolor }) => verticalcolor};
  height: 200px;
  padding-right: 0.5rem;
  @media (max-width: 768px) {
    height: 170px;
  }
  @media (max-width: 480px) {
    border-left: 0px;
    border-color: transparent;
  }
`;

export const InvisbleVerticalLine = styled.div<{ verticalcolor: any }>`
  border-left: 4px solid;
  border-color: transparent;
  padding-right: 0.5rem;
`;

export default function FeatureBar({
  manifestData,
}: Record<string, any>): JSX.Element {
  const featuresList = manifestData?.["features"];
  const title = manifestData?.["views"]["featureBar"]["title"];
  const config = manifestData?.["views"]["featureBar"]["config"];

  return (
    <Section
      bgColor={config.bgColor}
      id="featureBar"
    >
      {config.showHeading ? (
        <ViewHeader
          id="featureBar-heading"
          data-testid="featureBar-heading"
          titleColor={config?.titleColor ? config?.titleColor : "white"}
        >
          {title}
        </ViewHeader>
      ) : null}

      <FeatureDiv placeholder="featureBarDiv">
        {config.items?.map(
          (
            { feature, title, icon }: FeatureProps,
            index: number,
            { length }: any
          ) => (
            <HStack
              key={title + index}
              style={{ alignItems: "flex-start" }}
            >
              <VStack>
                <VStack>
                  {featuresList[feature]?.external === true ? (
                    // for features with external links
                    <ExternalFeature
                      tilecolor={config.tileColor}
                      href={featuresList[feature].url}
                      target="_blank"
                      rel="noopener noreferrer"
                      key={title + index}
                    >
                      {WebIcons(icon)}
                    </ExternalFeature>
                  ) : (
                    // for features reamining within the site
                    <Feature
                      tilecolor={config.tileColor}
                      to={feature}
                      key={title + index}
                    >
                      {WebIcons(icon)}
                    </Feature>
                  )}
                </VStack>
                <FeatureTitle>{title}</FeatureTitle>
              </VStack>
              {config.showVertical && length - 1 !== index ? (
                // show the veritcal lines between each tile/icon
                <VerticalLine
                  placeholder={"verticalDividers" + index}
                  verticalcolor={config.verticalColor}
                ></VerticalLine>
              ) : (
                // make lines transparent when showVertical is false
                // or screensize is mobile

                <InvisbleVerticalLine
                  verticalcolor={config.verticalColor}
                ></InvisbleVerticalLine>
              )}
            </HStack>
          )
        )}
      </FeatureDiv>
    </Section>
  );
}
